import * as React from "react";

import { AbsoluteModelPath, isModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { noop } from "../../../../../Common/TypingUtils";
import { PICKLIST_SEARCH, SELECT_USING, VALUE_EDITED } from "../../metricsAction";

import { MetricsActionPayload, trackAction } from "./MetricsProvider";

interface MetricsSenderState {
    savedValue?: null | string;
}

export const emptyMetricsValueSenderActions = {
    sendValue: noop,
    saveValue: noop,
};

export interface MetricsValueSenderActions {
    sendValue: (
        path: AbsoluteModelPath,
        value: string | undefined | null,
        searchTextLength?: number,
        itemsCount?: number,
        queryLimit?: number,
        gId?: string,
        control?: string
    ) => void;
    saveValue: (v: string | null | undefined) => void;
}

interface MetricsSenderProps {
    children: (metrics: MetricsValueSenderActions) => JSX.Element;
}

function valueSelector(
    _p: MetricsSenderProps,
    state: MetricsSenderState,
    path?: null | string,
    value?: string
): MetricsActionPayload {
    return {
        path: path,
        oldValue: state.savedValue,
        newValue: value,
    };
}

function picklistValueSelector(
    _p: MetricsSenderProps,
    state: MetricsSenderState,
    path?: null | string,
    value?: string,
    searchTextLength?: number,
    itemsCount?: number,
    queryLimit?: number,
    gId?: string,
    control?: string
): MetricsActionPayload {
    return {
        path: path,
        oldValue: state.savedValue,
        newValue: value,
        searchTextLength: searchTextLength,
        itemsCount: itemsCount,
        queryLimit: queryLimit,
        gId: gId,
        control: control,
    };
}

function selectValueSelector(
    _p: MetricsSenderProps,
    state: MetricsSenderState,
    path: string,
    newValue: string,
    itemsCount: number
): MetricsActionPayload {
    return {
        path: path,
        oldValue: state.savedValue,
        newValue: newValue,
        itemsCount: itemsCount,
        control: "Select",
    };
}

export class MetricsValueSender extends React.Component<MetricsSenderProps, MetricsSenderState> {
    public state: MetricsSenderState = {
        savedValue: "",
    };

    public render(): JSX.Element {
        return this.props.children({
            saveValue: this.saveValue,
            sendValue: this.sendValue,
        });
    }

    @trackAction(PICKLIST_SEARCH, picklistValueSelector)
    private sendPicklistUsingMetrics(
        _path: null | undefined | string,
        _v: string | null | undefined,
        _stl: number | undefined,
        _ic: number | undefined,
        _ql: number | undefined,
        _gId: string | undefined,
        _cntrl: string | undefined
    ): void {
        //
    }

    private readonly sendValue = (
        path: AbsoluteModelPath,
        value: string | null | undefined,
        searchTextLength: number | undefined,
        itemsCount: number | undefined,
        queryLimit: number | undefined,
        gId: string | undefined,
        control: string | undefined
    ): void => {
        const pathString = path != undefined && isModelPath(path) ? path.toLegacyPath() : path;
        if (value !== this.state.savedValue && control !== "Select") {
            this.sendMetrics(pathString, value);
        }

        if (control === "ComboBox" || control === "Picklist") {
            this.sendPicklistUsingMetrics(pathString, value, searchTextLength, itemsCount, queryLimit, gId, control);
        }

        if (control === "Select") {
            this.sendSelectUsingMetrics(pathString, value, itemsCount);
        }
    };

    @trackAction(SELECT_USING, selectValueSelector)
    private sendSelectUsingMetrics(_path?: null | string, _newValue?: string | null, _itemsCount?: number): void {
        //
    }

    @trackAction(VALUE_EDITED, valueSelector)
    private readonly sendMetrics = (_path: null | undefined | string, _v: string | null | undefined): void => {
        //
    };

    private readonly saveValue = (v: string | null | undefined): void => this.setState({ savedValue: v });
}
